<template>
    <div class="sidebar">
        <div class="container">
            <border :bottom="true" >
                <logos :height-size="73"/>
            </border>
            <div class="user-info">
                <span class="user-name strong">{{ userName }}</span>
            </div>
            <ul class="menu">
                <li class="menu-group">
                    <router-link :to="{name: 'home'}" exact class="menu-item">
                        <div class="menu-item-inner">
                            <i class="menu-icon fas fa-rocket"></i>
                            Мои задачи
                        </div>
                    </router-link>
                    <router-link :to="{name: 'files'}" exact class="menu-item">
                        <div class="menu-item-inner">
                            <i class="menu-icon fas fa-file"></i>
                            Мои файлы
                        </div>
                    </router-link>
<!--                    <router-link :to="{name: 'settings'}" exact class="menu-item">-->
<!--                        <div class="menu-item-inner">-->
<!--                            <i class="menu-icon fas fa-cog"></i>-->
<!--                            Настройки-->
<!--                        </div>-->
<!--                    </router-link>-->
                    <router-link :to="{name: 'datasets'}" exact class="menu-item">
                        <div class="menu-item-inner">
                            <i class="menu-icon fas fa-table"></i>
                            Датасеты
                        </div>
                    </router-link>
                </li>
                <li class="menu-group">
                    <router-link
                        v-for="platform in platforms"
                        :key="platform.code"
                        :to="{name: 'methods', params: {platform: platform.code}}"
                        class="menu-item"
                    >
                        <div class="menu-item-inner">
                            <i class="menu-icon" :class="platform.icon"></i>
                            {{ platform.name }}
                        </div>
                    </router-link>
                </li>
                <li class="menu-group">
                    <a target="_blank" href="http://my.kribrum.ru" class="menu-item">
                        <div class="menu-item-inner">
                            <i class="menu-icon fas fa-external-link-alt"></i>
                            Крибрум
                        </div>
                    </a>
                    <a target="_blank" href="http://jupyter.opendata.university" class="menu-item">
                        <div class="menu-item-inner">
                            <i class="menu-icon fas fa-external-link-alt"></i>
                            ЮПИТЕР ХАБ
                        </div>
                    </a>
                </li>
                <border :top="true">
                <li @click="logOut" class="menu-item logout">
                    Выйти
                </li>
                </border>
            </ul>
        </div>
    </div>
</template>

<script>
import Border from "./Border"
import Logos from "./Logos";

export default {
  name: 'Sidebar',
  components: {
    Border,
    Logos
  },
  computed: {
    userName() {
      return this.$store.state.session.firstName
    },
    platforms() {
      return this.$store.state.platforms
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('logOut')
      this.$router.push('/login')
    }
  },
  created() {
    this.$store.dispatch('fetchPlatforms')
  }
}
</script>

<style lang="sass" scoped>
    .logo-wrapper
        display: flex
        justify-content: center
        align-items: center
        flex-shrink: 0
        padding: 0 0 gridSteps(2) 0

    .logo
        height: 73px
        margin: 0 gridSteps(0.5) 0 gridSteps(0.5)

    .sidebar
        overflow: auto
        z-index: 1
        position: fixed
        left: 0
        top: 0
        height: 100vh
        background: #F2F2F2
        padding: gridSteps(2) 0 gridSteps(8) 0
        width: gridSteps(30)
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25)

    .container
        position: relative
        height: 100%
        width: 100%

    .user-info
        margin-top: gridSteps(2)
        padding-left: gridSteps(4)
        margin-bottom: gridSteps(2)

    .user-name
        color: $brand-blue

    .menu
        padding: 0
        margin: 0
        list-style: none

    .menu-group
        margin-bottom: gridSteps(2)

    .menu-item-inner
        padding-left: gridSteps(8)
        line-height: gridSteps(4)
        width: 100%
        position: relative

    .menu-dropdown-inner
        width: 100%
        display: block
        text-decoration: none
        color: inherit
        padding: gridSteps(1) 0 gridSteps(1) gridSteps(4)
        &:hover
            background: $blue

    .menu-item
        position: relative
        cursor: pointer
        text-decoration: none
        color: inherit

        &:hover
            .menu-item-inner
                background: $dark-blue
                color: white

            .menu-icon
                color: white

            .menu-dropdown
                display: block

    .router-link-active
        .menu-item-inner
            background: $dark-blue
            color: white

        .menu-icon
            color: white

    .router-link-active.menu-dropdown-inner
            background: $blue

    .menu-dropdown
        list-style: none
        display: none
        background: $light-blue
        padding: 0
        margin: 0

    .logout
        position: absolute
        width: 100%
        padding-top: gridSteps(2)
        padding-left: gridSteps(4)
        /*bottom: 0*/
        left: 0

        &:hover
            background: inherit
            color: inherit

    .menu-icon
        position: absolute
        top: gridSteps(2)
        transform: translateY(-50%)
        left: gridSteps(4)
        color: $dark-grey
</style>
